import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { useTheme } from '../../';
import { DropdownDivider } from './DropdownDivider';
export const DropdownHeader = ({ children, className, ...props }) => {
    const theme = useTheme().theme.dropdown.floating.header;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: twMerge(theme, className), ...props, children: children }), _jsx(DropdownDivider, {})] }));
};
